import Cookies from "js-cookie";
import { AppConstants } from "./constants";

/** Applies optional dev token from env when running with mock auth on localhost. */
export function initDevAuth(): void {
  if (!AppConstants.mockAuth) {
    return;
  }

  const devToken = process.env.REACT_APP_DEV_ACCESS_TOKEN;
  if (devToken && !Cookies.get("acto")) {
    Cookies.set("acto", devToken, AppConstants.getCookieOptions());
  }
}
